/** Primary nav with sub-menus — matches blueprint dropdown content.
 *  Each item can optionally have `children` (sub-links shown on hover/focus).
 *  CMS-controlled in a future iteration; today this is the source of truth.
 */
export const PRIMARY_NAV = [
  { label: "Home", to: "/" },
  {
    label: "Courses",
    to: "/courses",
    children: [
      { label: "Sri Vidya & Tantra", to: "/courses?cat=sri-vidya-tantra", desc: "The path of the Goddess", icon: "lotus" },
      { label: "Kundalini & Kriya", to: "/courses?cat=kundalini-kriya", desc: "Energy & awakening", icon: "flame" },
      { label: "Vedanta & Meditation", to: "/courses?cat=vedanta-meditation", desc: "Non-dual enquiry", icon: "compass" },
      { label: "Jyotisha", to: "/courses?cat=jyotisha", desc: "Vedic astrology", icon: "star" },
    ],
  },
  {
    label: "Sadhana",
    to: "/sadhana",
    children: [
      { label: "Guided Anushthana", to: "/sadhana?type=guided", desc: "Structured 11–49 day practice", icon: "flame" },
      { label: "Advanced Sadhanas", to: "/sadhana?type=advanced", desc: "For initiated practitioners", icon: "sparkle" },
      { label: "Daily Practice", to: "/sadhana?type=daily", desc: "Mantra & chakra kriya", icon: "infinity" },
    ],
  },
  { label: "Products", to: "/products" },
  { label: "Library", to: "/library" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "Vedic Astrology", to: "/services?cat=astrology", desc: "Birth-chart readings", icon: "star" },
      { label: "Vastu Consulting", to: "/services?cat=vastu", desc: "Space & direction", icon: "compass" },
      { label: "Numerology", to: "/services?cat=numerology", desc: "Name & number", icon: "infinity" },
      { label: "Spiritual Guidance", to: "/services?cat=spiritual-guidance", desc: "1:1 mentorship", icon: "lotus" },
    ],
  },
  { label: "Videos", to: "/videos" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About NVL", to: "/about", desc: "Our story & principles", icon: "lotus" },
      { label: "Research", to: "/research", desc: "Peer-reviewed scholarship", icon: "sparkle" },
      { label: "Contact", to: "/contact", desc: "Write to our team", icon: "compass" },
    ],
  },
];
